/**
 * Pure layout helpers for `InsightColumns.vue`. Kept out of the SFC
 * so the packing rule is unit-testable without a DOM.
 */

/** No single cell spans more tracks than this. A row's track count is
 *  the sum of its spans and may exceed it. */
export const MAX_TRACKS = 12;

/**
 * Re-pack authored spans onto a two-track grid — the "compact" step a
 * row takes when its container is 480–639px wide.
 *
 *   - A cell claiming more than half the authored row takes a whole
 *     line (span 2).
 *   - A one-track cell that would start a line on its own — it is the
 *     last cell, or the next cell needs a whole line — widens to fill
 *     it, so no line ends with an empty half.
 *
 * `[1,1,1,1]` → 2×2; `[1,1,1]` → `[1,1,2]`; `[3,1]` → `[2,2]`.
 */
export function compactSpans(spans: ReadonlyArray<number>, total: number): Array<1 | 2> {
  const raw = spans.map((s): 1 | 2 => (s * 2 > total ? 2 : 1));
  const out: Array<1 | 2> = [];
  let col = 0;
  raw.forEach((span, i) => {
    let s = span;
    if (s === 1 && col === 0 && (i === raw.length - 1 || raw[i + 1] === 2)) s = 2;
    out.push(s);
    col = (col + s) % 2;
  });
  return out;
}
